<template>
<!-- start template -->
<div id="template">
	
	<!-- start layout -->
	<div id="layout">
		
		<!--Begin Header-->
		<HeaderComponent />
		<!--End Header-->
		
		<router-view/>
		
		<!--Begin Banner-->
		<FooterComponent />
		<!--End Banner-->
		
	</div>
	<!-- end layout -->
	
</div>
<!-- end template -->
</template>

<script>
import HeaderComponent from './components/HeaderComponent';
import FooterComponent from './components/FooterComponent';

export default {
	components: {
		HeaderComponent,
		FooterComponent
	}
}
</script>

<style>

</style>